const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfSettlement extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfSettlement,
            "Each civilization gains 1 population",
            {}
        )
    }
}

module.exports = DevelopmentOfSettlement;